/** @jsxImportSource @emotion/react */
import { ReactComponent as Deposit } from "assets/icons/deposit.svg";
import { ReactComponent as Home } from "assets/icons/home.svg";
import { ReactComponent as Menu } from "assets/icons/menu.svg";
import { ReactComponent as Profile } from "assets/icons/profile.svg";
import { ReactComponent as Share } from "assets/icons/share.svg";
import PATH from "constants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { selectIsAuthenticated } from "store/auth";
import { setOpenSidebar } from "store/modal";
import { theme } from "styles/theme";

import { BottomTabStyles } from "./index.style";

const BottomTab = () => {
  const { t } = useTranslation("bottom-tab");
  const { profile } = useAppSelector((state) => state.user);
  const { pathname } = useLocation();
  const isAuth = useAppSelector(selectIsAuthenticated);
  const dispatch = useAppDispatch();

  const bottomTabValues = [
    {
      name: t("Menu"),
      icon: (color: string) => <Menu fill={color} />,
      link: "#",
      isMenu: true
    },
    {
      name: t("Share"),
      icon: (color: string) => <Share fill={color} />,
      link: PATH.profile.friendSharing,
      isAnimated: true
    },
    {
      name: t("Home"),
      icon: (color: string) => <Home fill={color} />,
      link: PATH.home
    },
    {
      name: t("Deposit"),
      icon: (color: string) => <Deposit fill={color} />,
      link: PATH.profile.trading
    },
    {
      name: t("Profile"),
      icon: (color: string) => <Profile fill={color} />,
      link: PATH.profile.home
    }
  ];

  const setIsSidebar = (val: boolean) => {
    dispatch(setOpenSidebar(val));
  };

  return (
    <div css={BottomTabStyles.container}>
      <div css={BottomTabStyles.listTab}>
        {bottomTabValues.map((item, index) => {
          const isActive = item.link === pathname;
          if (
            isAuth &&
            item.link === PATH.profile.trading &&
            profile?.upline !== "cashline"
          )
            return <React.Fragment key={item.link}></React.Fragment>;

          return (
            <Link
              to={item.link}
              onClick={() => {
                if (item.isMenu) {
                  setIsSidebar(true);
                  return;
                }
              }}
              key={`item-bottom-${index}`}
              css={BottomTabStyles.item}
            >
              <div
                css={[
                  BottomTabStyles.icon,
                  item.isAnimated && BottomTabStyles.spinAnimated
                ]}
              >
                {item.icon(
                  isActive ? theme.colors.secondary[900] : theme.colors.white
                )}
              </div>
              <span css={BottomTabStyles.name(isActive)}>{item.name}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTab;
